import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ShareLinkByEmailModal from 'components/documents/share_link_by_email_modal';
import CopyShareLinkModal, {
  bypassTokensWithVaultTypePropTypes,
  sharingCaUrlsWithVaultTypePropTypes
} from 'components/documents/copy_share_link_modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faPaperPlaneTop, } from '@fortawesome/pro-solid-svg-icons';
import { Dropdown, DropdownButton } from 'react-bootstrap-5';
import { faCaretDown } from '@fortawesome/pro-regular-svg-icons';

const SHARE_DOC_MODAL_DESCRIPTION = 'Easily invite anyone to view your locked documents.';
const WITH_GATES = ` Once sent, the invitee will adhere to the CA & Access settings you've configured for your
  documents.`;
const WITHOUT_GATES = ' The invitee will skip the waitlist.';

export default function ShareLink({
  bypassTokensWithVaultType,
  enableShareLink,
  fromEmails,
  sharingCaUrlsWithVaultType,
  propertyId,
  useVaultGates
}) {
  const [showShareByEmailModal, setShowShareByEmailModal] = useState(false);
  const [showCopyShareLinkModal, setShowCopyShareLinkModal] = useState(false);

  const openShareByEmailModal = () => setShowShareByEmailModal(true);
  const hideShareByEmailModal = () => setShowShareByEmailModal(false);
  const openCopyShareLinkModal = () => setShowCopyShareLinkModal(true);
  const hideCopyShareLinkModal = () => setShowCopyShareLinkModal(false);

  const canViewLinkToDocs = enableShareLink || sharingCaUrlsWithVaultType.length > 0;

  return (
    <React.Fragment>
      <DropdownButton
        id="share-actions"
        title={<span>Share <FontAwesomeIcon icon={faCaretDown}/></span>}
        variant="secondary"
      >
        {canViewLinkToDocs && (
          <Dropdown.Item href="#" onClick={openCopyShareLinkModal}>
            <FontAwesomeIcon icon={faLink}/>
            Link to documents
          </Dropdown.Item>
        )}
        <Dropdown.Item href="#" onClick={openShareByEmailModal}>
          <FontAwesomeIcon className="icon-container" icon={faPaperPlaneTop}/>
          Invite to View
        </Dropdown.Item>
      </DropdownButton>

      <ShareLinkByEmailModal
        description={`${SHARE_DOC_MODAL_DESCRIPTION}${useVaultGates ? WITH_GATES : WITHOUT_GATES}`}
        fromEmails={fromEmails}
        hideModal={hideShareByEmailModal}
        propertyId={propertyId}
        show={showShareByEmailModal}
        title="Invite to View by Email"
      />

      <CopyShareLinkModal
        bypassTokensWithVaultType={bypassTokensWithVaultType}
        enableShareLink={enableShareLink}
        sharingCaUrlsWithVaultType={sharingCaUrlsWithVaultType}
        show={showCopyShareLinkModal}
        onClose={hideCopyShareLinkModal}
      />
    </React.Fragment>
  );
}

ShareLink.propTypes = {
  bypassTokensWithVaultType: bypassTokensWithVaultTypePropTypes,
  enableShareLink: PropTypes.bool,
  fromEmails: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  sharingCaUrlsWithVaultType: sharingCaUrlsWithVaultTypePropTypes,
  propertyId: PropTypes.number.isRequired,
  useVaultGates: PropTypes.bool
};
